import HandyCollapse from "handy-collapse"
export default function initAccessibility() {
  const item = document.getElementsByClassName("accessibility-item")
  if (item.length > 0) {
    const accessibility = Array.from(item)

    if (accessibility.length > 0) {
      const myAccordion = new HandyCollapse({
        onSlideStart: (isOpen, contentID) => {
          let eventTrigger, newToggle
          if (isOpen) {
            eventTrigger = document.querySelector(`.toggle-on[data-hc-control='${contentID}']`)
            newToggle = document.querySelector(`.toggle-off[data-hc-control='${contentID}']`)
          } else {
            eventTrigger = document.querySelector(`.toggle-off[data-hc-control='${contentID}']`)
            newToggle = document.querySelector(`.toggle-on[data-hc-control='${contentID}']`)
          }
          document.querySelectorAll(`.toggle-off`).forEach(function (item) {
            item.classList.add("hidden")
          })
          document.querySelectorAll(`.toggle-on:not([data-hc-control='${contentID}'])`).forEach(function (item) {
            item.classList.remove("hidden")
          })
          eventTrigger.classList.add("hidden")
          newToggle.classList.remove("hidden")
        },
      })
      myAccordion.close()
    }
  }
}